import React from 'react';
import './TextContent.css';

const TextContent = ({
    type = 'light',
    title = '',
    content = ''
}) => {
    return (
        <>
            <section className={ type == 'dark' ? "text-content dark" : "text-content"}>
                <div className="view-container">
                    <div className="half-box">
                        {content}
                    </div>
                    <div className="background-text">
                        {title}
                    </div>
                </div>
            </section>
        </>
    )
}

export default TextContent;